const PARAM_LIST_SEPARATOR = ",";
const URL_IATA_LIST_SEPARATOR = "_";
const MULTISTOP_IATA_LIST_SEPARATOR = "|";
const LOCATION_IATA_CODE_AND_TYPE_SEPARATOR = ".";
const parseLocationCodes = (codeString) => {
    if (!codeString)
        return [];
    return codeString.split(URL_IATA_LIST_SEPARATOR).map((item) => {
        const [code, type] = item.split(LOCATION_IATA_CODE_AND_TYPE_SEPARATOR);
        return { code, type: type || "AIRPORT" };
    });
};
const parseLocationNames = (nameString) => {
    if (!nameString)
        return [];
    return nameString.split(PARAM_LIST_SEPARATOR);
};
const createLocation = (code, type, name, country) => {
    return {
        code,
        type: type,
        name,
        country,
        city: name,
        cityName: name,
        countryName: country,
        countryNameShort: country,
        regionName: ""
    };
};
export const convertSearchHistoryToSBState = (search) => {
    const type = (search.type || "ROUNDTRIP");
    const adults = parseInt(search.adults || "1", 10);
    const childrenAges = search.children ? search.children.split(PARAM_LIST_SEPARATOR).filter(Boolean).map(Number) : [];
    const cabinClass = (search.cabinClass || "ECONOMY");
    const isDirect = search.isDirect !== undefined
        ? !!search.isDirect
        : search.stops === "0";
    if (type === "MULTISTOP") {
        const fromCodes = (search.from || "").split(MULTISTOP_IATA_LIST_SEPARATOR);
        const toCodes = (search.to || "").split(MULTISTOP_IATA_LIST_SEPARATOR);
        const fromNames = (search.fromLocationName || "").split(MULTISTOP_IATA_LIST_SEPARATOR);
        const toNames = (search.toLocationName || "").split(MULTISTOP_IATA_LIST_SEPARATOR);
        const fromCountries = (search.fromCountry || "").split(MULTISTOP_IATA_LIST_SEPARATOR);
        const toCountries = (search.toCountry || "").split(MULTISTOP_IATA_LIST_SEPARATOR);
        const dates = (search.multiStopDates || "").split(MULTISTOP_IATA_LIST_SEPARATOR);
        const searchSegments = fromCodes.map((fromCode, idx) => {
            const fromCodesParsed = parseLocationCodes(fromCode);
            const toCodesParsed = parseLocationCodes(toCodes[idx] || "");
            const fromNamesParsed = parseLocationNames(fromNames[idx] || "");
            const toNamesParsed = parseLocationNames(toNames[idx] || "");
            return {
                from: fromCodesParsed.map((parsed, i) => createLocation(parsed.code, parsed.type, fromNamesParsed[i] || parsed.code, fromCountries[idx] || "")),
                to: toCodesParsed.map((parsed, i) => createLocation(parsed.code, parsed.type, toNamesParsed[i] || parsed.code, toCountries[idx] || "")),
                departureDate: dates[idx] || undefined,
                returnDate: undefined
            };
        });
        return {
            type,
            searchSegments,
            adults,
            children: childrenAges,
            cabinClass,
            isDirect
        };
    }
    else {
        const fromCodesParsed = parseLocationCodes(search.from || "");
        const toCodesParsed = parseLocationCodes(search.to || "");
        const fromNamesParsed = parseLocationNames(search.fromLocationName || "");
        const toNamesParsed = parseLocationNames(search.toLocationName || "");
        const fromCountries = (search.fromCountry || "").split(PARAM_LIST_SEPARATOR);
        const toCountries = (search.toCountry || "").split(PARAM_LIST_SEPARATOR);
        const from = fromCodesParsed.map((parsed, i) => createLocation(parsed.code, parsed.type, fromNamesParsed[i] || parsed.code, fromCountries[i] || ""));
        const to = toCodesParsed.map((parsed, i) => createLocation(parsed.code, parsed.type, toNamesParsed[i] || parsed.code, toCountries[i] || ""));
        return {
            type,
            searchSegments: [
                {
                    from,
                    to,
                    departureDate: search.depart || undefined,
                    returnDate: type === "ROUNDTRIP" ? search.return || undefined : undefined
                }
            ],
            adults,
            children: childrenAges,
            cabinClass,
            isDirect
        };
    }
};
